import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Store } from '@ngrx/store';
import { selectConfiguration, selectHasPolicy, selectIsGisTokenRegistered } from 'src/app/authentication/store/user.selector';
import { removeTagFromBuilding } from '../store/tag.action';
import { selectBuilding, selectCurrentBuildingTags } from '../store/building.selector';
import { Observable, of, Subject } from 'rxjs';
import { RefbatService } from '../service/refbat.service';
import { RefBatDto } from '../model/refbat.model';
import { switchMap, takeUntil } from 'rxjs/operators';
import { TranslocoDirective, TranslocoPipe } from '@jsverse/transloco';
import { MatCard, MatCardContent } from '@angular/material/card';
import { MatIcon } from '@angular/material/icon';
import { BuildingInfoComponent } from '../building-info/building-info.component';
import { MatList, MatListItem } from '@angular/material/list';
import { MatChipListbox } from '@angular/material/chips';
import { TagComponent } from '../../shared/components/chips/tag/tag.component';
import { AddTagComponent } from '../../shared/components/chips/add-tag/add-tag.component';
import { ExternalLinksComponent } from '../external-links/external-links.component';
import { BuildingRefbatComponent } from '../building-refbat/building-refbat.component';
import { MiniMapComponent } from '../../map/components/mini-map.component';
import { AsyncPipe } from '@angular/common';

@Component({
  selector: 'sibat-building-overview',
  templateUrl: './building-overview.component.html',
  styleUrls: ['./building-overview.component.scss'],
  imports: [
    TranslocoDirective,
    MatCard,
    MatIcon,
    MatCardContent,
    BuildingInfoComponent,
    MatList,
    MatListItem,
    MatChipListbox,
    TagComponent,
    AddTagComponent,
    ExternalLinksComponent,
    BuildingRefbatComponent,
    MiniMapComponent,
    TranslocoPipe,
    AsyncPipe,
  ],
})
export class BuildingOverviewComponent implements OnInit, OnDestroy {
  hasPolicyCasePreviewDetails$ = this.store.select(selectHasPolicy('case.previewDetails.get'));
  building$ = this.store.select(selectBuilding);
  tags$ = this.store.select(selectCurrentBuildingTags);
  gisTokenIsRegistered$ = this.store.select(selectIsGisTokenRegistered);
  configuration$ = this.store.select(selectConfiguration);
  refBatIds$: Observable<RefBatDto[]>;
  hasPolicyRefBat$ = this.store.select(selectHasPolicy('buildings.refbat.get'));

  private destroy$ = new Subject<void>();

  constructor(private store: Store, private route: ActivatedRoute, private refbatService: RefbatService) {}

  deleteTag(buildingId: number, tagName: string) {
    this.store.dispatch(removeTagFromBuilding({ tagName, buildingId }));
  }

  ngOnInit(): void {
    this.refBatIds$ = this.building$.pipe(
      switchMap(building => (building ? this.refbatService.search(building.id) : of([]))),
      takeUntil(this.destroy$)
    );
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
